export default __webpack_public_path__ + "atomic/_patterns/02-molecules/mobile-quick-links/_mobile-quick-links.twig";